import React from "react";
import styled from "styled-components";
import HeadImage1 from "../../assets/images/sub-head-img1.jpg";
import MHeadImage1 from "../../assets/images/m-sub-head-img1.jpg";
import {device} from "../../assets/styles/media.js";

const HeadImg = styled.div`
    position: relative;
    width: 100%;
    height: 340px;
    background: url(${HeadImage1}) no-repeat center top;
    background-size: cover;

    ${device.tablet}{
        background: url(${MHeadImage1}) no-repeat center top;
        background-size: cover;
    }
    ${device.mobile} {
        height: 210px;
        background: url(${MHeadImage1}) no-repeat center top;
        background-size: cover;
    }
    
`;


const GuideHead = () => {
    return (
        <HeadImg/>
    );
};

export default GuideHead;
